import ParseUtils from "../utils/parse-utils.ts";

export default class Location {
  public readonly address1: string;
  public readonly address2: string | null;
  public readonly address3: string | null;
  public readonly city: string;
  public readonly state: string;
  public readonly country: string;
  public readonly zipCode: string;

  constructor(
    address1: string,
    address2: string | null,
    address3: string | null,
    city: string,
    state: string,
    country: string,
    zipCode: string,
  ) {
    this.address1 = address1;
    this.address2 = address2;
    this.address3 = address3;
    this.city = city;
    this.state = state;
    this.country = country;
    this.zipCode = zipCode;
  }

  public static fromPayload(payload: Record<string, unknown>): Location {
    // non-optional fields
    const address1: string = ParseUtils.parseString(payload, "address1");
    const city: string = ParseUtils.parseString(payload, "city");
    const state: string = ParseUtils.parseString(payload, "state");
    const country: string = ParseUtils.parseString(payload, "country");
    const zipCode: string = ParseUtils.parseString(payload, "zip_code");

    // address2
    let address2: string | null = null;
    if (payload["address2"] !== undefined && payload["address2"] !== null) {
      address2 = ParseUtils.parseString(payload, "address2");
    }

    // address3
    let address3: string | null = null;
    if (payload["address3"] !== undefined && payload["address3"] !== null) {
      address3 = ParseUtils.parseString(payload, "address3");
    }

    return new Location(
      address1,
      address2,
      address3,
      city,
      state,
      country,
      zipCode,
    );
  }
}
